__turbopack_context__.v({
  "accordionContent": "ExpandableInfo-module__c6IgQG__accordionContent",
  "accordionItem": "ExpandableInfo-module__c6IgQG__accordionItem",
  "accordionTimelineDot": "ExpandableInfo-module__c6IgQG__accordionTimelineDot",
  "accordionTimelineLine": "ExpandableInfo-module__c6IgQG__accordionTimelineLine",
  "accordionTimelineRoot": "ExpandableInfo-module__c6IgQG__accordionTimelineRoot",
  "accordionTimelineWrapper": "ExpandableInfo-module__c6IgQG__accordionTimelineWrapper",
  "headerContent": "ExpandableInfo-module__c6IgQG__headerContent",
});
